import { GraduationCap, BookOpen, Sparkles, Heart } from "lucide-react";

const AREAS = [
  "Anxiety & overthinking",
  "Stress & burnout",
  "Self-esteem & identity",
  "Relationship dynamics",
  "Student life & academic pressure",
  "Personal growth & meaning",
];

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="container-soft pt-16 md:pt-24 pb-12">
        <div className="text-xs uppercase tracking-[0.25em] mb-4" style={{ color: "var(--primary-deep)" }}>About Me</div>
        <h1 className="font-display text-5xl sm:text-6xl mb-6 max-w-3xl" style={{ color: "var(--text-primary)" }}>
          Holding space for honest, gentle conversations.
        </h1>
        <p className="max-w-2xl text-lg leading-relaxed" style={{ color: "var(--text-secondary)" }}>
          I'm Sudiksha Kulharia — a Psychologist and Counsellor committed to making mental health support feel less intimidating and more human.
        </p>
      </section>

      <section className="container-soft py-12 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <img
            src="/images/sudiksha.jpg"
            alt="Sudiksha Kulharia — Psychologist & Counsellor"
            className="rounded-[2rem] w-full max-w-[380px] mx-auto aspect-[4/5] object-cover"
            data-testid="about-portrait"
          />
        </div>
        <div className="lg:col-span-7 space-y-10">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Heart size={18} style={{ color: "var(--primary-deep)" }}/>
              <h2 className="font-display text-3xl" style={{ color: "var(--text-primary)" }}>Professional Introduction</h2>
            </div>
            <p className="leading-relaxed" style={{ color: "var(--text-secondary)" }}>
              Counselling, to me, isn't about advice — it's about presence. My work is rooted in creating a space where you can be truly heard, without performance, without pretending you're okay when you're not. Whether you're navigating anxiety, a difficult chapter, or simply trying to understand yourself better, we'll move at the pace that feels right for you.
            </p>
          </div>

          <div>
            <div className="flex items-center gap-2 mb-3">
              <GraduationCap size={18} style={{ color: "var(--primary-deep)" }}/>
              <h2 className="font-display text-3xl" style={{ color: "var(--text-primary)" }}>Educational Background</h2>
            </div>
            <ul className="space-y-2 leading-relaxed" style={{ color: "var(--text-secondary)" }}>
              <li>• Master's Degree in Clinical Psychology</li>
              <li>• Bachelor's in Psychology (Honours)</li>
              <li>• Ongoing continuing education in evidence-based counselling approaches</li>
            </ul>
          </div>

          <div>
            <div className="flex items-center gap-2 mb-3">
              <BookOpen size={18} style={{ color: "var(--primary-deep)" }}/>
              <h2 className="font-display text-3xl" style={{ color: "var(--text-primary)" }}>Internship & Training</h2>
            </div>
            <p className="leading-relaxed" style={{ color: "var(--text-secondary)" }}>
              Trained across clinical and community settings — supporting individuals with anxiety, depression, relational concerns, student counselling, and life-stage transitions. Hands-on experience in one-on-one therapy, group facilitation, and crisis support.
            </p>
          </div>

          <div>
            <div className="flex items-center gap-2 mb-3">
              <Sparkles size={18} style={{ color: "var(--primary-deep)" }}/>
              <h2 className="font-display text-3xl" style={{ color: "var(--text-primary)" }}>Areas of Interest</h2>
            </div>
            <div className="flex flex-wrap gap-2">
              {AREAS.map((a) => (
                <span key={a} className="text-sm px-4 py-2 rounded-full" style={{ background: "var(--accent-beige)", color: "var(--text-primary)" }}>{a}</span>
              ))}
            </div>
          </div>

          <div>
            <h2 className="font-display text-3xl mb-3" style={{ color: "var(--text-primary)" }}>My Approach</h2>
            <p className="leading-relaxed" style={{ color: "var(--text-secondary)" }}>
              I blend client-centred, cognitive-behavioural, and mindfulness-informed practices — adapting to what serves you best. Sessions are collaborative, warm, and grounded in unconditional positive regard. You don't have to have it all figured out before you arrive.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
